import React, { useState, useEffect, useCallback } from 'react';
import api from '../utils/api'; 
import FullScreenLoader from '../components/Loader';
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';
import Container from '../components/Container';

const CampaignList = () => {
  const [campaignList, setCampaignList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(''); 
  const [debouncedSearch, setDebouncedSearch] = useState('');
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 20; 

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setCurrentPage(1);
    }, 500); 

    return () => clearTimeout(handler);
  }, [searchTerm]);

  const fetCampaignList = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(`/whatsapp/campaign-list`, {
        params: {
          page: currentPage,
          limit: itemsPerPage,
          search: debouncedSearch
        }
      }); 
      
      if (res.status === 200) {
        setCampaignList(res.data.campaign_list || []);
        setTotalPages(res.data.totalPages || 1);
      }
    } catch (err) {
      console.error("campaignList Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  }, [currentPage, debouncedSearch]);

  const handleStopCampaign = async (id) => {
    if (!window.confirm("Are you sure you want to stop this campaign?")) return;

    try {
      setLoading(true);
      await api.post(`/whatsapp/stop-campaign`, { campaignId: id });
      setLoading(false);
      fetCampaignList(); 
    } catch (err) {
      alert("Error stopping campaign");
    }
  };

  useEffect(() => {
    fetCampaignList();
  }, [fetCampaignList]);

  return (
    <Container onClick={fetCampaignList} title={'Broadcast Message Campaigns'}>
      {(loading ) && <FullScreenLoader />}

      <div style={searchContainer}>
        <input 
          type="text" 
          placeholder="Search by name or status etc..." 
          style={searchInput}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div style={tableWrapper}>
        <table style={tableStyle}>
          <thead>
            <tr style={thRow}>
              <th style={thStyle}>Date & Time</th>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Total Contacts</th>
              <th style={thStyle}>Total Processed</th>
              <th style={thStyle}>Percentage</th>
              <th style={thStyle}>Status</th>
              <th style={thStyle}>Action</th>
            </tr>
          </thead>
          <tbody>
            {campaignList.length > 0 ? (
              campaignList.map((camp, index) => (
                <tr key={index} style={trStyle}>
                  <td style={tdStyle}>{new Date(camp.created_at).toLocaleString()}</td>
                  <td style={tdStyle}><Link to={`/message-history/${camp.id}`} key={camp.id} style={{ textDecoration:'none',color:'black',cursor:'pointer' }}><strong>{camp.name}</strong></Link></td>
                  <td style={tdStyle}>{camp.total_contacts}</td>
                  <td style={tdStyle}>{camp.processed_count}</td>
                  <td style={tdStyle}><span style={statusBadge(camp.percentage)}>{camp.percentage}%</span></td>
                  <td style={tdStyle}>
                    <span style={statusBadge(camp.status)}>{camp.status ? camp?.status?.charAt(0)?.toUpperCase() + camp?.status?.slice(1) : 'N/A'}</span>
                  </td>
                  <td style={tdStyle}>
                    {camp.status === 'pending' ? (
                        <button 
                          onClick={() => handleStopCampaign(camp.id)} 
                          style={stopBtnStyle}
                        >
                          Stop
                        </button>
                      ) : (
                        <span style={{ color: '#999', fontSize: '12px' }}>N/A</span>
                      )}
                  </td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="5" style={{ textAlign: 'center', padding: '30px' }}>No records found.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={paginationStyle}>
        <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} style={pageBtn}>Prev</button>
        <span style={{ margin: '0 15px' }}>Page {currentPage} of {totalPages}</span>
        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)} style={pageBtn}>Next</button>
      </div>
    </Container>
  );
};

const stopBtnStyle = {
  padding: '6px 12px',
  backgroundColor: '#ff4d4f',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '12px',
  fontWeight: 'bold',
  transition: '0.3s hover',
};
const searchContainer = { marginBottom: '20px' };
const searchInput = { width: '97%', padding: '12px 20px', borderRadius: '8px', border: '1px solid #ddd' };
const tableWrapper = { backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' };
const tableStyle = { width: '100%', borderCollapse: 'collapse' };
const thRow = { backgroundColor: '#f1f3f5' };
const thStyle = { padding: '15px', textAlign: 'left', borderBottom: '2px solid #eee' };
const tdStyle = { padding: '15px', borderBottom: '1px solid #f0f0f0' };
const trStyle = { transition: '0.2s' };
const paginationStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' };
const pageBtn = { padding: '8px 20px', cursor: 'pointer', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '5px' };
const statusBadge = (status) => ({ padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', backgroundColor: (status === 'completed' || status == 100) ? '#dcfce7' : '#fee2e2', color: (status === 'completed' || status == 100) ? '#166534' : '#991b1b' });

export default CampaignList;